import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import logoDark from '../assets/images/fulllogo.png'
import logoLight from '../assets/images/fulllogo.png'
import agency from '../assets/images/demos/agency.png'
import software from '../assets/images/demos/software.png'
import startup from '../assets/images/demos/startup.png'
import application from '../assets/images/demos/application.png'
import gym from '../assets/images/demos/gym.png'
import business from '../assets/images/demos/business.png'
import finance from '../assets/images/demos/finance.png'
import corporate from '../assets/images/demos/corporate.png'
import marketing from '../assets/images/demos/marketing.png'
import eventmanagment from '../assets/images/demos/eventmanagment.png'
import freelancer from '../assets/images/demos/freelancer.png'
import portfolio from '../assets/images/demos/portfolio.png'
import studio from '../assets/images/demos/studio.png'
import lawyer from '../assets/images/demos/lawyer.png'
import contraction from '../assets/images/demos/contraction.png'
import analytics from '../assets/images/demos/analytics.png'
import coworking from '../assets/images/demos/coworking.png'
import hosting from '../assets/images/demos/hosting.png'
import cryptocurrency from '../assets/images/demos/index-cryptocurrency-02.png'
import health from '../assets/images/demos/health.png'
import career from '../assets/images/demos/career.png'
import itSolution from '../assets/images/demos/it-solution.png'
import property from '../assets/images/demos/property.png'
import education from '../assets/images/demos/education.png'
import charity from '../assets/images/demos/charity.png'

import {LuUser2} from '../assets/icons/vander'

export default function Navbar({navLight, bg}) {
    let [toggle, setToggle] = useState(false);
    let [manu, setManu] = useState();
    let [submenu, setSubManu] = useState();
    let [scrolling, setScrolling] = useState(false);

    let current = window.location.pathname

    useEffect(()=>{
        setManu(current);
        setSubManu(current)
        window.scrollTo(0, 0);

        const handleScroll = () => {
            const isScrolling = window.scrollY > 50;
            setScrolling(isScrolling);
        };
        window.addEventListener('scroll', handleScroll);

        return()=>{
            window.removeEventListener('scroll', handleScroll);
        }
        
    },[current])

  return (
        <header id="topnav" className={`defaultscroll sticky ${scrolling ? 'nav-sticky' : ''} ${bg ? 'bg-light' : ''}`}>
            <div className="container">
                {navLight ? (
                    <Link className="logo" to="/">
                        <span className="logo-light-mode">
                            <img src={logoDark} className="l-dark" height="75" alt=""/>
                            <img src={logoLight} className="l-light" height="75" alt=""/>
                        </span>
                    <img src={logoLight} className="logo-dark-mode" height="75" alt=""/>
                </Link> 
                ) : (

                    <Link className="logo" to="/">
                        <img src={logoDark} height="75" className="logo-light-mode" alt=""/>
                        <img src={logoLight} height="75" className="logo-dark-mode" alt=""/>
                    </Link>                
                )}

                <div className="menu-extras">
                    <div className="menu-item">
                        <Link to="#" className={`navbar-toggle ${toggle ? 'open' : ''}`} id="isToggle" onClick={(e)=>{setToggle(!toggle)}}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </Link>
                    </div>
                </div>  
        
                <div id="navigation" style={{display : toggle ? 'block' : 'none'}}>
                    <ul className={`navigation-menu nav-right ${navLight ? 'nav-light' : ''}`}>
                        <li className={`${manu === '/' ? 'active' : ''}`}><Link to="/" className="sub-menu-item">Home</Link></li>
                        <li className={`${manu === '/page-why-india' ? 'active' : ''}`}><Link to="/page-why-india" className="sub-menu-item">Why India?</Link></li>
                        <li className={`${manu === '/page-services' ? 'active' : ''}`}><Link to="/page-services" className="sub-menu-item">Services</Link></li>
                        <li className={`${manu === '/page-about' ? 'active' : ''}`}><Link to="/page-about" className="sub-menu-item">About Us</Link></li>
                        <li className={`${manu === '/podcasts' ? 'active' : ''}`}><Link to="/podcasts" className="sub-menu-item">Podcasts</Link></li>
                        {/* <li className={`${manu === '/page-cases' ? 'active' : ''}`}><Link to="/page-cases" className="sub-menu-item">Case Studies</Link></li> */}
                        <li className={`${manu === '/page-ai-lab' ? 'active' : ''}`}><Link to="/page-ai-lab" className="sub-menu-item">AI Labs</Link></li>
                        <li className={`${manu === '/contact' ? 'active' : ''}`}><Link to="/contact" className="sub-menu-item">Contact</Link></li>
                        </ul>
                </div>
            </div>
        </header>
  )
}
